/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Logosettings1Inputs */

const en_entity_logosettings1 = /** @type {(inputs: Entity_Logosettings1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logo Settings`)
};

const de_entity_logosettings1 = /** @type {(inputs: Entity_Logosettings1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logo-Einstellungen`)
};

/**
* | output |
* | --- |
* | "Logo Settings" |
*
* @param {Entity_Logosettings1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_logosettings1 = /** @type {((inputs?: Entity_Logosettings1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Logosettings1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_logosettings1(inputs)
	return de_entity_logosettings1(inputs)
});
export { entity_logosettings1 as "entity_logoSettings" }